// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eab0352a","453":"258b012d","455":"64d107ec","592":"59a1b684"}[chunkId] + ".chunk.js";
};